import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareKeys from '../../../locales/keys';
export var getDiscountTooltipModel = function getDiscountTooltipModel(discount, currency, discountsMetadataMap, billerConfigurationId, futureDiscountIndex, pastDiscountIndex, futureDiscountsLength, pastDiscountsLength) {
  var _discountsMetadataMap, _discountsMetadataMap2;
  return {
    billerConfigurationId: billerConfigurationId,
    Currency: currency,
    Name: ((_discountsMetadataMap = discountsMetadataMap[discount.DiscountId]) === null || _discountsMetadataMap === void 0 ? void 0 : _discountsMetadataMap.StorefrontText) || ((_discountsMetadataMap2 = discountsMetadataMap[discount.DiscountId]) === null || _discountsMetadataMap2 === void 0 ? void 0 : _discountsMetadataMap2.Name),
    savings: discount.Amount || discount.DiscountAmount,
    startDate: discount.StartDate,
    startDateText: i18n.translate(CustomerCareKeys.STARTS_ON),
    futureDiscountText: i18n.translate(CustomerCareKeys.FUTURE_DISCOUNTS),
    pastDiscountIndex: pastDiscountIndex,
    futureDiscountIndex: futureDiscountIndex,
    futureDiscountsLength: futureDiscountsLength,
    pastDiscountsLength: pastDiscountsLength,
    expirationDate: discount.DiscountExpirationDate,
    expirationDateText: i18n.translate(CustomerCareKeys.EXPIRES_DATE)
  };
};